import { DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate } from '../fetch';

export interface CountryResponse {
  id: number;
  name: string;
  iso3: string;
}

export enum CountryOrderColumn {
  ID = 'id',
  CREATED = 'createdAt',
  UPDATED = 'updatedAt',
}

export interface CountryGetParams extends PagingParams {
  orderByColumn?: CountryOrderColumn;
}

export const useCountriesGet = (): FetchGet<
  PagingDataResponse<CountryResponse>,
  CountryGetParams
> => useFetchGet(
  'countries',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

// export const useCountriesForSelectGet = (): FetchGet<
//   Pick<CountryShort, 'id'>[],
//   CountryGetParams
// > => useFetchGet(
//   'countries/for-select',
//   {
//     autoStart: false,
//     startStateLoading: false,
//   },
// );

export type CountryById = CountryResponse

export const useCountriesGetById = (countryId?: string): FetchGet<
  CountryById
> => useFetchGetId(
  'countries',
  countryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type CountryCreateResponse = CountryResponse
export type CountryCreateData = Omit<CountryResponse, 'id' | 'updateAt' | 'createdAt'>

export const useCountriesCreate = (): FetchCreate<
  CountryCreateResponse,
  DefaultFetchError,
  CountryCreateData
> => useFetchCreate(
  'admin/countries',
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export type CountryUpdateResponse = CountryCreateResponse;

export interface CountryUpdateData extends Partial<CountryCreateData> {
  id?: string;
}

export const useCountriesUpdate = (countryId?: string): FetchUpdate<
  CountryUpdateResponse,
  DefaultFetchError,
  CountryUpdateData
> => useFetchUpdate(
  'admin/countries',
  countryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export const useCountriesDelete = (countryId?: string): FetchDelete => useFetchDelete(
  'admin/countries',
  countryId,
  {
    autoStart: false,
    startStateLoading: false,
  },
);

export default {
  useCountriesGet,
  useCountriesGetById,
  useCountriesCreate,
  useCountriesUpdate,
  useCountriesDelete,
};
